import React from 'react';

import {Tab, Tabs} from '@pb/kit-component-tabs-v2';

import {ADMIN_RIGHTS_PROFILE_TABS} from '../../constants';

import {profileTabs} from './profile-tabs.module.styl';

type Props = {
    activeTab: string,
    onTabChange: (tab: string, recordId?: number) => void,
};

export const ProfileTabs = ({activeTab, onTabChange}: Props) => (
    <Tabs className={`${profileTabs} sticky-tool-ribbon`} onChange={onTabChange} value={activeTab} style={{width: '100%'}}>
        <Tab value={ADMIN_RIGHTS_PROFILE_TABS.PERMISSIONS.name} {...ADMIN_RIGHTS_PROFILE_TABS.PERMISSIONS}/>
        <Tab value={ADMIN_RIGHTS_PROFILE_TABS.ASSIGNED_USERS.name} {...ADMIN_RIGHTS_PROFILE_TABS.ASSIGNED_USERS}/>
        <Tab value={ADMIN_RIGHTS_PROFILE_TABS.HISTORY.name} {...ADMIN_RIGHTS_PROFILE_TABS.HISTORY}/>
    </Tabs>
);
